import { Pill, vars } from "@vericus/cadmus-ui";

import * as styles from "./student-prompt.css";

export function CadmusAIPill() {
  return (
    <span className={styles.pillReveal}>
      <Pill basic color={vars.colors.lilac200} textColor={vars.colors.lilac700}>
        Contextualised with Cadmus AI
      </Pill>
    </span>
  );
}
